
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Das Coronavirus ist für die ältere Bevölkerung besonders gefährlich. Von den
4065 bestätigten Fällen bei über 80-Jährigen in der Schweiz überlebte über ein
Viertel die Krankheit Covid-19 nicht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;